import { c as _c } from "react/compiler-runtime";
import { envConfigs } from '@/config';
import { Brand as BrandType } from '@/shared/types/blocks/common';
export function Copyright(t0) {
  const $ = _c(5);
  const {
    brand
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date().getFullYear();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const currentYear = t1;
  const t2 = brand?.url || envConfigs.app_url;
  const t3 = brand?.target || "";
  const t4 = brand?.title || envConfigs.app_name;
  let t5;
  if ($[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = <div className="text-muted-foreground text-sm">© {currentYear}{" "}<a href={t2} target={t3} className="text-primary hover:text-primary/80 cursor-pointer underline underline-offset-4">{t4}</a>, All rights reserved</div>;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}